module.exports = __webpack_public_path__ + "img/DerSong2.fcb88879.jpg";